__turbopack_context__.v({
  "columns": "CoreColumns-module-scss-module__N09KYG__columns",
});
